<template>
  <div class="today-alarm">
    <div class="middletitleright dn-title-bg">
      <div class="buttom">
        <button v-for="(items,index) in btnarry"
                @click="clickbtn(index)"
                :key="index"
                :id="index"
                v-show="items.type"
                :class="activecode==index?'btn btnactive dn-title-bg':'btn dn-title-bg'">{{items.name}}</button>
      </div>
      <div class="buttom1">
        <el-select v-model="value"
                   v-if="showType"
                   @change="changeType"
                   placeholder="请选择"
                   class="sClass">
          <el-option v-for="item in typeData"
                     :key="item.id"
                     :label="item.name"
                     :value="item.id">
          </el-option>
        </el-select>
      </div>
    </div>
    <div class="bottomright dn-content-bg">
      <div :id="echartsId"
           class="lineBox"
           ref="lineBox"
          v-resize="resize">
      </div>
      <div :id="echartsIdTwo"
           class="lineBox"
           ref="echartsIdTwo"
           v-resize="resize">
      </div>
    </div>
  </div>
</template>
<script>
let vm
import uuidv1 from 'uuid/v1'
export default {
  beforeRouteLeave(to, form, next) {},
  props: {
    selectedMeasure: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      btnarry: [{id:0,name:"线电压",type:false},{id:1,name:"相电压",type:false},{id:2,name:'频率',type:true} ],
      activecode: 0,
      realTimeData: [],
      voltageData: [], //右边电压数据
      echarts: null,
      echartsTwo: null,
      echartsId: uuidv1(),
      echartsIdTwo: uuidv1(),
      time: 60,
      interTime: null,
      value: 'AB线',
      typeIndex: 0,
      showType: true,
      options: [
        {
          data: [
            {
              id: 0,
              name: 'AB线'
            },
            {
              id: 1,
              name: 'BC线'
            },
            {
              id: 2,
              name: 'CA线'
            }
          ]
        },
        {
          data: [
            {
              id: 0,
              name: 'A相'
            },
            {
              id: 1,
              name: 'B相'
            },
            {
              id: 2,
              name: 'C相'
            }
          ]
        }
      ],
      typeData: []
    }
  },
  created() {
    this.typeData = this.options[this.typeIndex].data
  },
  methods: {
    resize() {
      let vm = this;
      if (vm.echarts && vm.echartsTwo) {
        vm.echarts.resize();
        vm.echartsTwo.resize();
      }
    },
    //调接口拿取数据
    getData() {
      let vm = this
      let apiArr = []
      apiArr.push(
        vm.$api.tmp.getLineVoltageDeviationRealTime(
          vm.selectedMeasure.measureId
        )
      ) //实时曲线-线电压偏差
      apiArr.push(
        vm.$api.tmp.getPhaseVoltageDeviationRealTime(
          vm.selectedMeasure.measureId
        )
      ) //实时曲线-相电压偏差
      apiArr.push(
        vm.$api.tmp.getFrequencyRealTime(vm.selectedMeasure.measureId)
      ) //实时曲线-频率
      apiArr.push(
        vm.$api.tmp.getFrequencyDeviationRealTime(vm.selectedMeasure.measureId)
      ) //实时曲线-频率偏差
      Promise.all(apiArr)
        .then(resArr => {
          //相电压
          resArr.forEach((item,index)=>{
              if(!item.success){
                  vm.$message.error(item.msg)
              }
          })
          vm.btnarry[0].type=resArr[0].data.type
          vm.btnarry[1].type=resArr[1].data.type
          if(!vm.btnarry[vm.activecode].type){
              let Index=vm.btnarry.findIndex(obj=>{
                  return obj.type==true;
              })
              if(Index>-1){
                  vm.activecode=Index;
              }
          }
          /* 頻率 */
          if(vm.activecode=='2'){
              vm.showType = false
          }
          vm.realTimeData = [
            {
              series: [],
              xData: [],
              title: ['AB线电压', 'BC线电压', 'CA线电压'],
            //   title: ['AB线电压', 'BC线电压', 'CA线电压', '三相平均线电压'],
              unit: '%',
              unitS: '%'
            },
            {
              series: [],
              xData: [],
              title: ['A相电压', 'B相电压', 'C相电压'],
            //   title: ['A相电压', 'B相电压', 'C相电压', '三相平均电压'],
              unit: '%',
              unitS: '%'
            },
            {
              series: [],
              xData: [],
              title: ['频率'],
              unit: 'Hz',
              unitS: 'Hz'
            },
            {
              series: [],
              xData: [],
              title: ['频率偏差'],
              unit: 'Hz',
              unitS: 'Hz'
            }
          ]
          vm.realTimeData[0] = vm.detalRealData(
            resArr[0].data,
            vm.realTimeData[0],
            'deviation',
            'line'
          )
          vm.realTimeData[1] = vm.detalRealData(
            resArr[1].data,
            vm.realTimeData[1],
            'deviation',
            'line'
          )
          vm.realTimeData[2] = vm.detalRealData(
            resArr[2].data.data,
            vm.realTimeData[2],
            'frequency',
            'line'
          )
          vm.realTimeData[3] = vm.detalRealData(
            resArr[3].data,
            vm.realTimeData[3],
            'frequency',
            'bar'
          )
          vm.getVoltage(vm.activecode)
          vm.$nextTick(() => {
            vm.getLineEchart(
              vm.realTimeData[vm.activecode],
              vm.echartsId,
              vm.echarts
            )
            if( vm.activecode==2){
                vm.voltageData = vm.realTimeData[3]
            }
            vm.getLineEchart(vm.voltageData, vm.echartsIdTwo, vm.echartsTwo)
            if (vm.interTime) {
              clearTimeout(vm.interTime)
            }
            if (vm.time > 0) {
              vm.interTime = setTimeout(() => {
                vm.getData()
              }, vm.time * 1000)
            }
          })
        })
        .catch()
    },
    //匹配电压，电流基波值  lineData图标数据   resDat接口数据   legend图例数据
    //处理实时数据  //echartdata  title图例   lineData  //接口数据 type 用于区分是线电压还是频率  echartTyoe echarts类型
    detalRealData(lineData, echartdata, type, echartTyoe) {
      let newLineData = []
      if (type == 'frequency') {
        newLineData = lineData
      } else {
        for (let i in lineData) {
            if(i=='type'){
            }else{
                newLineData.push(lineData[i])
            }
            
        }
      }
      //放图例
      echartdata.title.forEach((temp, i) => {
        echartdata.series.push({
          data: [],
          name: temp,
          type: echartTyoe,
          smooth: true
        })
      })
      if (type == 'frequency') {
        echartdata.xData = []
        newLineData.forEach((item, i) => {
          echartdata.series[0].data.push(
            item.value == '' ? '' : Number(item.value).toFixed(2)
          )
          echartdata.xData.push(item.time)
        })
      } else {
        newLineData.forEach((item, i) => {
          echartdata.xData = []
          item.forEach((temp, j) => {
            if (echartdata.series[i]) {
              echartdata.series[i].data.push(
                temp.value == '' ? '' : Number(temp.value).toFixed(2)
              )
            }
            echartdata.xData.push(temp.time)
          })
        })
      }
      //填充数据
      return echartdata
    },
    //obj Echarts数据   echartId Echarts Id  echartObj Echarts对象
    getLineEchart(obj, echartId, echartObj) {
      let vm = this
      if (echartObj == null) {
        echartObj = vm.$echarts.init(document.getElementById(echartId))
      } else {
        echartObj.clear()
      }
      var option = {
        legend: {
          height: '80%',
          left: 'center',
          bottom: '5%',
          data: obj.legend,
          textStyle:{
              color:"#666"
          }
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'cross',
            label: {
              backgroundColor: '#6a7985'
            }
          }
        },
        color: ['#CCCC00', '#52CCA3', '#00AAFF'],
        xAxis: {
          type: 'category',
          data: obj.xData,
          axisLine:{
              lineStyle:{
                  color:"#666"
              }
          }
        },
        yAxis: {
          type: 'value',
          name: obj.unit,
          scale: true /*按比例显示*/,
          axisLine:{
              lineStyle:{
                  color:"#666"
              }
          }
        },
        series: obj.series
      }
      echartObj.setOption(option, true)
      window.addEventListener('resize', function() {
        echartObj.resize()
      })
    },
    //实时图标切换tab
    clickbtn(svgcode) {
      let vm = this
      this.activecode = svgcode
      if (vm.options[svgcode]) {
        vm.typeData = vm.options[svgcode].data
        vm.value = vm.typeData[0].id
        vm.showType = true
        vm.getVoltage(0)
      } else {
        vm.showType = false
        vm.voltageData = vm.realTimeData[3]
      }
      vm.getLineEchart(vm.realTimeData[svgcode], vm.echartsId, vm.echarts)
      vm.getLineEchart(vm.voltageData, vm.echartsIdTwo, vm.echartsTwo)
    },
    //切换偏差值
    changeType(val) {
      let vm = this
      vm.getVoltage(val)
      vm.getLineEchart(vm.realTimeData[vm.activecode], vm.echartsId, vm.echarts)
      vm.getLineEchart(vm.voltageData, vm.echartsIdTwo, vm.echartsTwo)
    },
    //获取偏差值
    getVoltage(val) {
      let vm = this
      vm.voltageData = {
        series: [vm.realTimeData[vm.activecode].series[val]],
        xData: vm.realTimeData[vm.activecode].xData,
        title: [vm.realTimeData[vm.activecode].title[val]],
        unit: vm.realTimeData[vm.activecode].unitS
      }
    }
  },
  watch: {
    selectedMeasure: {
      handler(newVal, oldVal) {
        let vm = this
        vm.getData()
      },
      deep: true
    }
  }
}
</script>
<style lang="scss" scoped>
.today-alarm{
    display: flex;
    flex-flow: column;
    height:100%;
    width:100%;
}
.middletitleright {
  color: #fff;
  font-weight: bold;
  display: flex;
  justify-content: space-between;
  font-size: 16px;
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
}
.bottomright {
//   height: 39vh;
  height: calc(100% - 33px);
  border-bottom-left-radius: 4px;
  border-bottom-right-radius: 4px;
  display: flex;
}
.buttom {
  overflow: hidden;
  display: flex;
  justify-content: space-between;
}
.buttom1 {
  overflow: hidden;
  display: flex;
  justify-content: space-between;
  margin-right: 5px;
}
.bottomrightcontent {
  background: #fff;
  border-right: 1px solid #eee;
  border-left: 1px solid #eee;
  border-bottom: 1px solid #eee;
//   height: 671px;
  flex:1;
  border-bottom-left-radius: 4px;
  border-bottom-right-radius: 4px;
}
.btn {
   display: inline-block;
    height: 1.8rem;
    line-height: 1.9rem;
    border:none;
    padding: 0 0.9rem;
    white-space: nowrap;
    text-align: center;
    font-size: 0.7rem;
    cursor: pointer;
    outline: none;
    font-weight: bold;
    height: 33px;
    color:#fff;
}
.btnactive {
  color: #0197EE !important;
}
.lineBox {
  width: 48%;
  height: 100%;
  overflow: hidden;
}
.sClass {
  height: 33px;
  line-height: 33px;
  width: 150px;
}
.sClass ::v-deep .el-input__inner {
  -webkit-appearance: none;
  background-color: #fff;
  background-image: none;
  border-radius: 4px;
  border: 1px solid #dcdfe6;
  box-sizing: border-box;
  color: #606266;
  display: inline-block;
  font-size: inherit;
  height: 25px;
  line-height: 25px;
  outline: 0;
  padding: 0 15px;
  transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
  width: 100%;
}
</style>